import script from "./esamiDownload.vue?vue&type=script&setup=true&lang=ts"
export * from "./esamiDownload.vue?vue&type=script&setup=true&lang=ts"

import "./esamiDownload.vue?vue&type=style&index=0&id=8626a670&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8626a670"]])

export default __exports__